import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';

const InactivityWarning = ({ secondsRemaining, onContinue, onLogout }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl p-8 max-w-md mx-4 animate-fade-in">
        <div className="flex flex-col items-center text-center">
          <div className="p-4 bg-amber-100 dark:bg-amber-900/30 rounded-full mb-4">
            <AlertTriangle className="h-10 w-10 text-amber-600 dark:text-amber-400" />
          </div>
          
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
            Sesión por expirar
          </h2>
          
          <p className="text-slate-600 dark:text-slate-400 mb-4">
            Tu sesión se cerrará automáticamente por inactividad.
          </p>
          
          <div className="flex items-center gap-2 mb-6">
            <Clock className="h-5 w-5 text-slate-500" />
            <span className="text-3xl font-mono font-bold text-slate-900 dark:text-white">
              {secondsRemaining}
            </span>
            <span className="text-slate-500">segundos</span>
          </div>
          
          <div className="flex gap-3 w-full">
            <Button 
              variant="outline" 
              onClick={onLogout}
              className="flex-1"
            >
              Cerrar Sesión
            </Button>
            <Button 
              onClick={onContinue}
              className="flex-1 bg-indigo-600 hover:bg-indigo-700"
            >
              Continuar
            </Button>
          </div>
          
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-4">
            Por seguridad, las sesiones inactivas se cierran después de 15 minutos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;
